const LOGIN_ROUTE = '/login';
const LOGOUT_ROUTE = '/logout';
export {
  LOGIN_ROUTE,
  LOGOUT_ROUTE
};
